import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {UserPrivilegeService} from '../../../services/common/user-privilege/user-privilege.service';
import {LdapAuthenticationApiService} from '../../../services/api/settings/administration/ldap-authentication/ldap-authentication-api.service';
import * as _ from 'lodash';
import {LoaderService} from '../../../services/common/loader-service/loader.service';
import {RoleTypeEnum} from '../../../services/enums/role-type.enum';
@Component({
  selector: 'ldap-authentication',
  templateUrl: './ldap-authentication.component.html',
  styleUrls: ['./ldap-authentication.component.scss'],
})
export class LdapAuthenticationComponent implements OnInit, AfterViewInit {

  canSubmit: boolean;
  testResult = '';
  testResultServer = '';
  showCertificate = false;
  ldapAuthentication: any;
  errorMessage = '';

  doUseGroupMembershipOptions = [
    {value: false, text: 'Active Directory'},
    {value: true, text: 'Open Ldap'}
  ];

  authenticationOrderList: any = [
    {description: 'External first', bool: false},
    {description: 'Local first', bool: true}
  ];
  b: boolean;

  constructor(
    private ldapAuthenticationApiService: LdapAuthenticationApiService,
    private userPrivilege: UserPrivilegeService,
    private loaderService: LoaderService
    ) {}


  ngOnInit(): void {
    this.canSubmit = this.userPrivilege.isAuthorized(RoleTypeEnum.SECURITY_ADMIN);
    this.loaderService.showMainContainer();
    this.initializeScope();
  }

  submit(): void {
    this.showCertificate = false;

    if (!this.ldapAuthentication.isSSL) {
      this.ldapAuthentication.certificate = null;
    }

    this.ldapAuthenticationApiService.updateAuthenticationLDAPConfiguration(this.ldapAuthentication).subscribe(ldapServer => {
      this.showCertificate = false;
      this.setLdapAuthenticationConfiguration(ldapServer);
    });
  }

  onFileChange(files): void {
    if (files && files.length === 1) {
      const fileReader: FileReader = new FileReader();
      fileReader.onloadend = (content) => {
        this.ldapAuthentication.certificate = fileReader.result as string;
      };
      fileReader.onerror = (event) => {
        this.ldapAuthentication.certificate = '';
        this.errorMessage =  fileReader.result as string;
      };
      fileReader.readAsText(files[0]);
    }
  }

  testConnectivity(): void {
    this.ldapAuthenticationApiService.testAuthenticationLDAPConfiguration(this.ldapAuthentication).subscribe(() => {
      this.testResult = 'Ldap server connection test successful';
    }, (fail) => {this.testResult = 'Failed: ' + fail.error.description; });
  }

  testServerConnectivity(): void {
    const ldapAuthenticationCopy = _.cloneDeep(this.ldapAuthentication);
    ldapAuthenticationCopy.testConnectivity.password = null;
    ldapAuthenticationCopy.testConnectivity.name = null;

    this.ldapAuthenticationApiService.testAuthenticationLDAPConfiguration(ldapAuthenticationCopy).subscribe(() => {
      this.testResultServer = 'Ldap server connection test successful';
    }, (fail) => {
      this.testResultServer = 'Failed: ' + fail.error.description;
    });
  }


  initializeScope(): void {
    this.ldapAuthentication = {mappings: { doUseGroupMembership: false}, testConnectivity: {}, parsedCertificate: {}};
    this.showCertificate = false;

    this.ldapAuthenticationApiService.getAuthenticationLDAPConfiguration().subscribe((ldapServer) => {
      this.setLdapAuthenticationConfiguration(ldapServer);
      this.loaderService.hideMainContainer();
    });
  }

  setLdapAuthenticationConfiguration(ldapServer): void {
    delete ldapServer.testConnectivity;
    Object.assign(this.ldapAuthentication, _.cloneDeep(ldapServer));

    if (ldapServer.parsedCertificate.issuer != null) {
      this.showCertificate = true;
    }
  }

  ngAfterViewInit(): void {
   /* console.log(this.form);
    this.form.form.statusChanges.subscribe(() => {
      console.log(this.form);
    });*/
  }


}
